/** 最小 t 签名，便于单测传入独立 i18next 实例 */
export type LogScanReasonTranslate = (key: string, options?: Record<string, unknown>) => unknown;

const UNRESOLVED_PLACEHOLDER = /\{\{[^}]+\}\}/;

/**
 * LogScan 轨迹「原因」文案解析（纯函数）。
 *
 * PDA 弹窗类 messageKey 是 `{ title, message }` 对象结构，直接 `t(key)` 会得到
 * "returned an object instead of string"；且 LogScan 不保存插值参数，message 中的占位符无法替换。
 * 按顺序取第一个可用字符串：
 *  1. key 本身是字符串文案（destination 取 notes，与原有行为一致）
 *  2. `${key}.log`：专供轨迹展示、不含占位符的文案
 *  3. `${key}.message`：不含未替换占位符时使用
 *  4. `${key}.title`
 *  5. 原样返回 key
 */
export const resolveLogScanReason = (
    t: LogScanReasonTranslate,
    messageKey: string,
    notes?: string | null,
): string => {
    const lookup = (key: string): string | null => {
        const value = t(key, { destination: notes ?? '', defaultValue: '', returnObjects: true });
        return typeof value === 'string' && value !== '' ? value : null;
    };

    const direct = lookup(messageKey);
    if (direct !== null) return direct;

    const log = lookup(`${messageKey}.log`);
    if (log !== null) return log;

    const message = lookup(`${messageKey}.message`);
    if (message !== null && !UNRESOLVED_PLACEHOLDER.test(message)) return message;

    return lookup(`${messageKey}.title`) ?? messageKey;
};
